// @flow

import * as React from "react";

import useAsyncState from "../../hooks/useAsyncState";
import API from "../../api/user";
import Modal from "../organisms/Modal";
import Button from "../atoms/Button";
import TextButton from "../atoms/TextButton";
import Icon from "../atoms/Icon";
import Loader from "../atoms/Loader";

type PropsType = {
    active: boolean,
    onClose: Function,
    attendee?: {
        checked_in: boolean,
        name: string,
        ticketType: string,
        email: string,
    },
    event: any,
    qrScanned: boolean,
    onScanAnotherQrCode: () => void,
    onCheckInSuccess: (qrScanned: string, attendeeName: string) => void,
    checkinDisabled: boolean,
};

const TicketDetailManageModal = (props: PropsType): React.Node => {
    return (
        <Modal
            aside={true}
            active={props.active}
            className="ticket-detail-manage-modal"
            onOverlayClick={props.onClose}
            onClose={props.onClose}
        >
            <Modal.Header>Ticket details</Modal.Header>
            <Modal.Content>
                <TicketDetailManageModalInner {...props} />
            </Modal.Content>
        </Modal>
    );
};

const TicketDetailManageModalInner = (props: PropsType): React.Node => {
    const [state, localActions] = useAsyncState();
    const [checkedIn, setCheckedIn] = React.useState(false);
    const statusClassList = ["ticket-detail-manage-modal__eyebrow"];

    const isCheckedIn =
        (props.attendee && props.attendee.is_checkin) || checkedIn;

    React.useEffect(() => {
        if (props.qrScanned && !isCheckedIn) {
            // initialised with qr code scan, automatically try check in
            handleCheckInClick();
        }
    }, []); // eslint-disable-line

    const handleCheckInClick = () => {
        if (props.attendee && props.event) {
            localActions.request();

            API.userCheckInEventTicket(
                props.event.ID,
                props.attendee.event_registration_id,
                props.attendee.name
            )
                .then((data: any) => {
                    // successful check in
                    localActions.success();
                    setCheckedIn(true);
                    if (props.onCheckInSuccess) {
                        props.onCheckInSuccess(
                            props.qrScanned,
                            props.attendee.name
                        );
                    }
                })
                .catch(error => {
                    localActions.fail(
                        error.message ||
                            "There was an issue confirming check in."
                    );
                });
        }
    };

    const handleScanAnotherCode = () => {
        props.onClose();
        props.onScanAnotherQrCode();
    };

    if (props.attendee && isCheckedIn) {
        statusClassList.push("checked-in");
    }

    return (
        <>
            {props.attendee ? (
                <div className="container-fluid ticket-detail-manage-modal__content__inner">
                    {!state.error ? (
                        <>
                            {!state.loading && props.attendee.full_name ? (
                                <>
                                    {isCheckedIn ? (
                                        <div className="ticket-detail-manage-modal__icon">
                                            <Icon name="tick" />
                                        </div>
                                    ) : null}

                                    <div className={statusClassList.join(" ")}>
                                        {isCheckedIn
                                            ? "CHECKED IN"
                                            : "NOT CHECKED IN"}
                                    </div>

                                    <h2 className="ticket-detail-manage-modal__name">
                                        {props.attendee.full_name}
                                    </h2>
                                    <hr />
                                    <div className="ticket-detail-manage-modal__label email">
                                        Email
                                    </div>
                                    <div className="ticket-detail-manage-modal__desc email">
                                        {props.attendee.email}
                                    </div>
                                    <div className="ticket-detail-manage-modal__label">
                                        Ticket type
                                    </div>
                                    <div className="ticket-detail-manage-modal__desc">
                                        {props.attendee.type}
                                    </div>

                                    {!isCheckedIn &&
                                    !props.qrScanned &&
                                    !props.checkinDisabled ? (
                                        <Button
                                            className="ticket-detail-manage-modal__cta"
                                            styles={["green"]}
                                            aria-label="Check in"
                                            onClick={handleCheckInClick}
                                            loading={state.loading}
                                            success={!!state.success}
                                        >
                                            Confirm check in
                                        </Button>
                                    ) : null}

                                    {props.qrScanned ? (
                                        <Button
                                            className="ticket-detail-manage-modal__cta"
                                            styles={["green"]}
                                            aria-label="Scan another QR Code"
                                            onClick={handleScanAnotherCode}
                                            loading={state.loading}
                                            success={!!state.success}
                                        >
                                            Scan another QR Code
                                        </Button>
                                    ) : null}
                                </>
                            ) : (
                                <>
                                    <br />
                                    <br />
                                    <Loader
                                        className="center-xs"
                                        inline={true}
                                        active={state.loading}
                                    />
                                    <br />
                                    <br />
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="ticket-detail-manage-modal__icon is-error">
                                <Icon name="close" />
                            </div>

                            <h2 className="ticket-detail-manage-modal__heading heading-2">
                                Check in unsuccessful
                            </h2>

                            <p>{state.error}</p>

                            <br />
                        </>
                    )}

                    <p
                        className="center-xs"
                        style={{ display: "flex", marginTop: "28px" }}
                    >
                        <TextButton onClick={props.onClose}>Back</TextButton>
                    </p>
                </div>
            ) : null}
        </>
    );
};

export default TicketDetailManageModal;
